// CreateCategory.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CreateCategory.css'; // Asegúrate de tener los estilos adecuados
import CategoryList from './CategoryList'; // Asegúrate de que este componente está correctamente implementado

const apiUrl = process.env.REACT_APP_API_URL || 'https://www.nualily.es';

const CreateCategory = () => {
    const [categoryData, setCategoryData] = useState({
        name: '',
        description: ''
    });

    const [categories, setCategories] = useState([]); // Estado para almacenar las categorías existentes
    const [loading, setLoading] = useState(true); // Estado de carga
    const [error, setError] = useState(null); // Estado de error
    const [editingCategory, setEditingCategory] = useState(null); // Estado para editar

    // Función para obtener todas las categorías
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/categories`); // Solicitud pública, no requiere encabezado Authorization
            setCategories(response.data);
        } catch (error) {
            console.error('Error al obtener las categorías:', error);
            setError('Error al cargar las categorías. Intenta de nuevo más tarde.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories(); // Llama a la función al cargar el componente
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCategoryData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token'); // Obtiene el token JWT del localStorage

            if (!token) {
                alert('No estás autenticado. Por favor, inicia sesión.');
                return;
            }

            if (editingCategory) {
                // Actualizar categoría existente
                const response = await axios.put(`${apiUrl}/api/categories/${editingCategory._id}`, categoryData, {
                    headers: {
                        Authorization: token // Enviar el token sin el prefijo 'Bearer'
                    }
                });

                console.log('Categoría actualizada:', response.data); // Log de la categoría actualizada
                alert('Categoría actualizada con éxito');
                setEditingCategory(null); // Resetear el estado de edición
            } else {
                // Crear nueva categoría
                const response = await axios.post(`${apiUrl}/api/categories`, categoryData, {
                    headers: {
                        Authorization: token // Enviar el token sin el prefijo 'Bearer'
                    }
                });

                console.log('Categoría creada:', response.data); // Log de la categoría creada
                alert('Categoría creada con éxito');
            }

            setCategoryData({ name: '', description: '' }); // Reinicia el formulario
            fetchCategories(); // Actualiza la lista de categorías después de crear o editar
        } catch (error) {
            console.error('Error al enviar el formulario:', error);
            alert('Error: ' + (error.response?.data?.message || error.message));
        }
    };

    // Función para manejar la edición de una categoría
    const handleEdit = (category) => {
        setEditingCategory(category);
        setCategoryData({
            name: category.name,
            description: category.description
        });
    };

    // Función para cancelar la edición
    const handleCancelEdit = () => {
        setEditingCategory(null);
        setCategoryData({ name: '', description: '' });
    };

    return (
        <div className="create-category-container">
            <form onSubmit={handleSubmit} className="create-category-form">
                <h2>{editingCategory ? 'Editar Categoría' : 'Crear Categoría'}</h2>
                <input 
                    type="text" 
                    name="name" 
                    placeholder="Nombre de la categoría" 
                    value={categoryData.name} 
                    onChange={handleChange} 
                    required 
                />
                <textarea 
                    name="description" 
                    placeholder="Descripción de la categoría" 
                    value={categoryData.description} 
                    onChange={handleChange} 
                   /* required */
                />
                <button type="submit">{editingCategory ? 'Actualizar Categoría' : 'Crear Categoría'}</button>
                {editingCategory && (
                    <button type="button" onClick={handleCancelEdit} className="cancel-button">
                        Cancelar
                    </button>
                )}
            </form>

            {/* Mostrar la lista de categorías */}
            <h2>Lista de Categorías</h2>
            {loading ? (
                <p>Cargando categorías...</p>
            ) : error ? (
                <p className="error-message">{error}</p>
            ) : (
                <CategoryList 
                    categories={categories} 
                    fetchCategories={fetchCategories} 
                    onEdit={handleEdit} // Pasar handleEdit como onEdit
                />
            )}
        </div>
    );
};

export default CreateCategory;
